import { rootApi } from "../../api/rootApi";

export const adminUsersApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllAdminUsers: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/users`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
    addAdminUser: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/admin/add`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
        body: params.data,
      }),
    }),
    updateAdminUser: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/admin/users/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
        body: params.data,
      }),
    }),
    deactivateAdminUser: builder.mutation({
      query: (params) => ({
        method: "DELETE",
        url: `/admin/users/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
  }),
});

export const {
  useGetAllAdminUsersMutation,
  useAddAdminUserMutation,
  useUpdateAdminUserMutation,
  useDeactivateAdminUserMutation,
} = adminUsersApi;
